var _desc, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetpostdata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Iris-Scan-1--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Iris Scan 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.5 12S6.9 7 12 7s8.5 5 8.5 5 -3.4 5 -8.5 5 -8.5 -5 -8.5 -5Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 10s2 0 2 2c0 0 0 2 -2 2 0 0 -2 0 -2 -2 0 0 0 -2 2 -2Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.75 4.5V2.25c0 -0.39782 0.158035 -0.77936 0.43934 -1.06066C1.47064 0.908035 1.85218 0.75 2.25 0.75H4.5",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.25 4.5V2.25c0 -0.39782 -0.158 -0.77936 -0.4393 -1.06066C22.5294 0.908035 22.1478 0.75 21.75 0.75H19.5",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.75 19.5v2.25c0 0.3978 0.158035 0.7794 0.43934 1.0607 0.2813 0.2813 0.66284 0.4393 1.06066 0.4393H4.5",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.25 19.5v2.25c0 0.3978 -0.158 0.7794 -0.4393 1.0607s-0.6629 0.4393 -1.0607 0.4393H19.5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetpostdata);
export default __webpack_public_path__ + "static/media/getpostdata.940eb12a3f6647ced7a51b5138a9739f.svg";
export { ForwardRef as ReactComponent };